
import { DialogTitle } from "@/components/ui/dialog"

interface PaymentSummaryProps {
  selectedOptionPrice?: number;
  currentAmount?: number | null;
}

export function PaymentSummary({ selectedOptionPrice, currentAmount }: PaymentSummaryProps) {
  const displayAmount = currentAmount !== null ? currentAmount : selectedOptionPrice;

  return (
    <DialogTitle className="text-2xl font-bold text-center">
      Payment Details
      {displayAmount !== undefined && (
        <div className="text-lg font-normal mt-2 text-purple-600">
          Amount: ${displayAmount.toFixed(2)}
        </div>
      )}
    </DialogTitle>
  );
}
